<p class="abha-address-title">{{ 'ABHA.ADDRESS_STEP_TITLE' | translate }}</p>

<p class="text-muted f-s-12" *ngIf="isLoading">{{ 'ABHA.ADDRESS_LOADING' | translate }}</p>
<p class="text-muted f-s-12" *ngIf="!isLoading && !suggestionsError && suggestions.length === 0">
  {{ 'ABHA.ADDRESS_NO_SUGGESTIONS' | translate }}
</p>

<div *ngIf="suggestionsError" class="m-b-16">
  <p role="alert">{{ suggestionsError }}</p>
  <button mat-stroked-button type="button" [disabled]="isLoading || isSaving" (click)="loadSuggestions()">
    {{ 'ABHA.SCAN_RETRY' | translate }}
  </button>
</div>

<ng-container *ngIf="suggestions.length > 0">
  <label class="d-block m-b-8">{{ 'ABHA.ADDRESS_SUGGESTIONS' | translate }}</label>
  <div class="abha-address-suggestions">
    <button *ngFor="let suggestion of suggestions" mat-stroked-button type="button"
      [class.abha-address-picked]="addressControl.value === suggestion" [disabled]="isSaving"
      (click)="onPickSuggestion(suggestion)">
      {{ suggestion }}
    </button>
  </div>
</ng-container>

<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ 'ABHA.ADDRESS_CUSTOM_LABEL' | translate }}</mat-label>
  <input matInput [formControl]="addressControl" [maxlength]="maxLength" [readonly]="isSaving" />
  <mat-hint>{{ 'ABHA.ADDRESS_POLICY' | translate }}</mat-hint>
  <mat-error *ngIf="addressControl.hasError('required')">
    {{ 'ABHA.ADDRESS_REQUIRED' | translate }}
  </mat-error>
  <mat-error *ngIf="addressControl.hasError('abhaAddressPolicy')">
    {{ 'ABHA.ADDRESS_POLICY' | translate }}
  </mat-error>
</mat-form-field>

<div class="d-flex justify-content-end m-t-16">
  <button *ngIf="currentAddress" mat-stroked-button type="button" class="m-r-8" [disabled]="isSaving" (click)="kept.emit()">
    {{ 'ABHA.ADDRESS_KEEP' | translate: { address: currentAddress } }}
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="isSaving" (click)="onSetAddress()">
    {{ (isSaving ? 'ABHA.ADDRESS_SAVING' : 'ABHA.ADDRESS_SET') | translate }}
  </button>
</div>
